import { useRef, useEffect, useState } from 'react'
import { useHistory, Link, Redirect } from 'react-router-dom'
import { store } from '~/Store'
import { Avatar, Button, Dropdown, Menu, Layout, List, Modal } from 'antd'
import { MoreVertical } from 'react-feather'
import { useAclData } from './AclDataProvider'
import FilterPanel from './FilterPanel'
import WeaverService from 'Services/WeaverService'
import './EntityListContainer.scss'

{ Content } = Layout

export default ({
  actions = [],
  canCreate = true,
  filterer,
  filterPanelOpts,
  Icon,
  init,
  itemProps,
  onRemove,
  reducerKey,
  title,
  singularRoute,
  singular,
}) ->

  onRemove ?= (item) -> item.destroy()

  ({ items }) ->

    childRef = useRef(null)
    [aclData, dispatch] = useAclData()
    [filteredItems, setFilteredItems] = useState([])
    [initting, setInitting] = useState(true)
    history = useHistory()

    itemProps.description ?= (item) -> item.id()

    useEffect( ->
      ( ->
        await refresh()
        setInitting(false)
      )()
      undefined
    , [])

    refresh = ->
      data = await init()
      dispatch(data)

    MenuItem = ({ item, fn, content, requiresConfirmation = false, danger = false, accessFn }) ->
      useEffect( ->
        ( ->
          if accessFn?
            setHasAccess(await accessFn(item))
          else
            setHasAccess(true)
        )()
        undefined
      , [])

      [hasAccess, setHasAccess] = useState(false)

      <Menu.Item
        onClick={->
          if requiresConfirmation
            Modal.confirm({
              title: "You are about to #{content().toLowerCase()} #{itemProps.title(item)}"
              content: "Are you sure you want to #{content().toLowerCase()} #{itemProps.title(item)}?"
              onOk: ->
                await fn(item)
                refresh()
              okText: 'Yes'
              okButtonProps: { 'data-testid': "btn-#{content().toLowerCase()}" }
              okType: 'danger'
              cancelText: 'No'
            })
          else
            await fn(item, history)
            refresh()
        }
        danger={danger}
        disabled={!hasAccess}
        key={content(item)}
        data-testid="acl-#{content(item).toLowerCase()}-#{itemProps.title(item)}">
        { content(item) }
      </Menu.Item>

    dropdownMenu = (item) ->
      <Menu>
        { actions.map((props) -> MenuItem({ item, ...props})) }
      </Menu>

    ItemMenu = ({ item, index }) ->
      if actions.length > 0
        <Dropdown.Button
          trigger="click"
          type="text"
          icon={<MoreVertical data-testid="more-actions-btn-#{ index }" />}
          overlay={dropdownMenu(item)}
        />
      else
        <div></div>

    if _.isEmpty(store.getState().user.userAcls)
      <Redirect to='/' />
    else
      <Content style={{ display: 'flex', flexDirection: 'column'}}>
        <div ref={childRef}
          style={{
            zIndex: 1
            padding: '6px 16px',
            display: 'flex',
            flexDirection: 'row',
            borderBottom: '1px solid var(--borderColor)'
          }}
        >
          <h3 style={{ margin: 0, marginTop: '3px' }}>{ title }</h3>
          <span style={{ flex: 1 }} />
          {
            if canCreate
              <Button
                type="primary"
                onClick={ ->
                  history.push("/acl/#{reducerKey}/new")
                }
                data-testid="create-entity"
              >Create a { singular }</Button>
          }
          <FilterPanel
            title={title}
            data={aclData[reducerKey]}
            filterPanelOpts={filterPanelOpts}
            searchFilter={filterer}
            onFilterItems={setFilteredItems}
          />
        </div>
        <div style={{ padding: '0px 16px', flex: '1 1 auto', overflow: 'auto', minHeight: '0px' }}>
          {
            if initting
              <div />
            else
              <List
                itemLayout="horizontal"
                dataSource={_.sortBy(filteredItems, (item) -> itemProps.title(item).toLowerCase())}
                className="entity-list"
                size="large"
                renderItem={(item, i) ->
                  <List.Item
                    actions={[<ItemMenu item={item} index={i} />]}
                  >
                    <List.Item.Meta
                      avatar={<Avatar
                        className="entity-list-item-avatar"
                        icon={<span className="anticon"><Icon width="1em" height="1em"/></span>}
                      />}
                      title={
                        <Link
                          to="/acl/#{singularRoute}/#{item.id()}"
                          data-testid={"entity-#{ itemProps.key(item) }"}
                        >{ itemProps.title(item) } { itemProps.titleExtra?(item) }</Link>
                      }
                      description={itemProps.description(item)}
                    />
                  </List.Item>
                }
              />
          }
        </div>
      </Content>
